
import { NavLink } from "react-router-dom";

import './../styles/project.css';
import React, { useState, useEffect } from 'react';
import Errors from  './../components/errors/Errors';

const Projects =() =>{

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    useEffect(() => {
      fetch('https://inkochetkov.github.io/data/projects.json') 
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          setData(data);
          setLoading(false);
        })
        .catch(error => {
          setError(error);
          setLoading(false);
        });
    }, []);
  
    if (loading) return <div>Loading...</div>;
    if (error) return <Errors e={error.message} />;

    return (
    <>  
     <div className="main">
        <ul className="grids">
            {data.map((item, index) => 
            <li className="grids_item">
                <div className="grid">
                    <div className="grid_image">
                        <img src={item.img} alt="img" />
                        <div className="grid_content">   
                            <h2 className="grid_title">{item.name}</h2>
                            <p className="grid_text">{item.type}</p> 
                            <NavLink to={`/project/${item.name}`}   style={{ textDecoration: 'none' }}>                             
                                <button className="btn grid_btn">Read More</button>                      
                            </NavLink>
                        </div> 
                    </div>
                </div>
            </li>)}
        </ul>
        </div>  
       
    </>
    );
}

export default Projects;